import React from "react";
import { Box, IconButton, Typography, Skeleton } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

const OutletSkeleton = () => {
  return (
    <Box sx={{ p: 2 }}>
      {/* Header Skeleton */}
      <Box>
        <Box sx={{ display: "flex", gap: 1, mb: 4 }}>
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton variant="text" width="60%" height={30} />
        </Box>

        {/* Shops List Skeleton */}
        <Box sx={{ display: "flex", gap: 4, flexDirection: "column", mt: 5 }}>
          {Array.from(new Array(3)).map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              height={100}
              sx={{ borderRadius: "10px" }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default OutletSkeleton;
